export default "__VITE_ASSET__DARYcnhe__"